<template>
    <div>
        <div class="inside">
            <el-dropdown @command="handleCommand" class="dropdown" trigger="hover">
      <el-button class="dropdown">
        {{ dropdown }}
        <img src="@/assets/images/bookIcons/downarrow.png" class="img" />
      </el-button>
      <el-dropdown-menu slot="dropdown" class="dropdown-detail">
        <el-dropdown-item command="全部">全部</el-dropdown-item>
        <el-dropdown-item command="书名">书名</el-dropdown-item>
        <el-dropdown-item command="目录标引">目录标引</el-dropdown-item>
        <el-dropdown-item command="全文">全文</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
            <el-input placeholder="请输入内容" v-model="input" class="input">
                <img slot="prefix" src="@/assets/images/bookIcons/search.png" class="search-img"
                @click="searchInBook(input)">
            </el-input>
            <button class="confirm" data-warden-title="检索结果" :data-warden-info="`书内检索--${input}`" @click="searchInBook(input)">书内检索</button>
            <button class="confirm" data-warden-title="检索结果" :data-warden-info="`全库检索--${input}`" @click="search(input)">全库检索</button>
        </div>
    </div>
</template>

<script>
import MySearchDropDown from './MySearchDropDown.vue'
export default {
  name: 'RetrieveDetailSearch',
  components: {MySearchDropDown},
  props: {
    bookId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dropdown: '全部',
      commandMap: {
        全部: 'all',
        书名: 'bookName',
        目录标引: 'keyword',
        全文: 'text'
      },
      selectList: ['全部', '书名', '目录标引', '全文'],
      input: ''
    }
  },
  methods: {
    handleCommand (command) {
      this.dropdown = command
    },
    search (item) {
      this.$global.searchDTO.returnType = 'all'
      this.$router.push({
        path: '/retrieve/retrievehome/retrieveResult',
        query: {
          searchText: item,
          command: this.commandMap[this.dropdown],
          exactSearch: 1
        }
      })
    },
    searchInBook (item) {
      this.$router.push({
        path: '/retrieve/retrievehome/retrieveResult',
        query: {
          searchText: item,
          bookId: this.bookId,
          command: this.commandMap[this.dropdown],
          exactSearch: 1
        }
      })
    }
  }
}
</script>

<style scoped>
.inside {
    display: flex;
    flex-direction: row;
    padding: 35px 80px 24px 80px;
}
.input {
    width: 658px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    margin-left: 13px;
    font-size:16px
}
.search-img{
    width: 23px;
    height: 23px;
    cursor: pointer;
}
.input >>> .el-input__prefix{
    top: 9px;
    left:15px
}
.input >>> .el-input__inner{
    padding-left: 60px;
}
.confirm {
    width: 93px;
    height: 40px;
    background: #9E5C1D;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 0;
    padding: 0;
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
    margin-left: 10px;
}
.input>>>.el-input__inner:focus{
    border-color: #9E5C1D;
}
.inside {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 35px 0px 10px 0px;
  height: #9e5c1d;
}

.dropdown {
  width: 165px;
  height: 40px;
  font-size: 16px;
  text-align: left;
  border-radius: 0;
}

.img {
  width: 15px;
  float: right;
  transition: all 0.3s;
}

.dropdown-detail {
  width: 165px;
}
/*
.input {
  width: 658px;
  height: 40px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  margin-left: 13px;
  font-size: 16px;
} */

.search-img {
  width: 23px;
  height: 23px;
}

/* .inside >>> .el-button {
  color: #634c37;
  font-size: 16px;
}

.input >>> .el-input__suffix {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  cursor: pointer;
} */

/* .input >>> .el-input__prefix {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  cursor: pointer;
} */

/* .input >>> .el-input__suffix:hover {
  background-color: #00000011;
}

.input >>> .el-input__inner {
  padding-left: 60px;
  border-radius: 0;
} */

.confirm {
  width: 93px;
  height: 40px;
  background: #9e5c1d;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 0;
  padding: 0;
  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  margin-left: 10px;
}

.el-button:focus,
.el-button:hover {
  color: #9e5c1d;
  background-color: #ffffff;
  border-color: #9e5c1d;
}

/* .el-button:focus .img, */
.el-button:hover .img {
  transform: rotate(180deg);
}

.el-dropdown:hover,
.el-dropdown:focus {
  color: #9e5c1d;
  background-color: #ffffff;
  border-color: #ecded1;
}

.dropdown-detail >>> .el-dropdown-menu__item:hover {
  color: #9e5c1d;
  background-color: #ecded1;
  border-color: #9e5c1d;
}

.input >>> .el-input__inner:focus {
  border-color: #9e5c1d;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
}

.input-wrapper .tips {
  font-size: 14px;
  color: #634c37;
  margin-top: 10px;
  text-align: left;
  padding-left: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/RetrieveDetailSearch.vue